import { IBreadcrumbProps, ISearchBoxStyles, SearchBox } from "@fluentui/react";
import { Paper } from "@mui/material";
import { ChangeEvent, CSSProperties, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PARTNER_SEARCH_STYLES } from "../components/PartnerSearch/PartnerSearch.styles";
import PartnerDataGrid from "../components/PartnerSearch/PartnerSearchGridComponent";
import { logPageView } from "../helper/AppInsightsHelper";
import { CustomBreadcrumb } from "../SharedComponents/CustomBreadcrumb";
import { debounce } from "../Utils/js-common";

const style = {
  searchBoxParent: {
    marginBottom: 18
  } as CSSProperties,
  seachBox: {
    root: {
      width: "60%",
      marginLeft: "20%",
      marginTop: 3,
      borderRadius: 4
    }
  } as Partial<ISearchBoxStyles>
};
const breadcrumbStyles = {
  root: {
    fontSize: "14px",
    margin: 0,
    "--itemLink-color": "rgb(0, 120, 212)"
  },
  item: {
    fontSize: "inherit"
  },
  itemLink: {
    fontSize: "inherit",
    color: "var(--itemLink-color)",
    ":hover": {
      background: "none",
      textDecoration: "underline",
      color: "var(--itemLink-color)"
    }
  }
};

export default function PartnerSearch() {
  const navigate = useNavigate();
  const key = "partner-search-bc";
  const [searchText, setSearchText] = useState("");
  const bcrops: IBreadcrumbProps = {
    items: [
      { text: "Home", key: "home", onClick: () => navigate("/") },
      { text: "Explore Partners", key: "explore-partners", isCurrentItem: true }
    ],
    styles: breadcrumbStyles
  };

  // Search function
  const performSearch = (query: string) => setSearchText(query);

  // Debounced search function
  const debouncedSearch = debounce(performSearch);

  const onChange = (event?: ChangeEvent<HTMLInputElement>) => debouncedSearch(event?.target.value ?? "");

  const onClear = (event?: any) => performSearch(event?.target.value || "");

  useEffect(() => logPageView("Partner Search Page", window.location.href), []);

  return (
    <div className="mainCard" style={{ marginRight: 10 }}>
      <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
        <CustomBreadcrumb {...bcrops} key={key} />
      </div>
      <Paper className={PARTNER_SEARCH_STYLES.PARTNER_SEARCH_DATA_GRID.CLASS_NAMES.GRID_AND_FILTER_PILL_CONTAINER}>
        <div style={style.searchBoxParent}>
          <SearchBox
            disableAnimation
            onChange={onChange}
            onClear={onClear}
            onSearch={performSearch}
            placeholder="Search Partner by PartnerOneId, PartnerOne Name, PartnerId and PartnerName"
            styles={style.seachBox}
          />
        </div>
        {/* <div style={{ marginBottom: 10 }}>
          <WarningBanner message="Note: All the data shown below is at MPN Id level." />
        </div> */}
        <PartnerDataGrid searchText={searchText} />
      </Paper>
    </div>
  );
}
